import React, { useEffect, useState } from 'react';
import CurrencyInput from 'react-currency-input-field';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { OrderTypeEnum } from '../../../lib/enums/order-type.enum';
import lang from '../../../lib/language';
import { TradingPlan } from '../../../lib/models/crm/types';
import { getDefaultSelectableTradingPLanFromState } from '../../../lib/store/crm/helpers';
import { RootState } from '../../../lib/store/index';
import { calculateTimeRemaining, isDateBeforeNow } from '../../../lib/util/DateTimeHelpers';

import { useIsIosDevice } from '../../../hooks';
import { Error } from '../..';

import styles from '../styles.module.scss';

type Props = {
  initialPrice: number;
  orderType: string;
  targetPriceError: string;
  setTargetPrice: (value: number) => void;
  setTargetPriceError: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  disabled?: boolean;
}

const LimitPriceInput = ({
  disabled, orderType, initialPrice, targetPriceError, setTargetPrice, setTargetPriceError, onFocus, onBlur,
}: Props) => {
  const isIosUser = useIsIosDevice();
  const decimalSeparator = isIosUser ? ',' : '.';
  const groupSeparator = isIosUser ? '.' : ',';

  const [isTournamentStarted, setIsTournamentStarted] = useState(false);

  const tradingPlan = useSelector<RootState, TradingPlan>(
    (state: RootState) => getDefaultSelectableTradingPLanFromState(state.crm),
  );

  useEffect(() => {
    if (tradingPlan) {
      calculateTimeRemaining(tradingPlan.plans_accounts_activation, setIsTournamentStarted);
    }
  }, [tradingPlan]);

  const isTournamentEnded = isDateBeforeNow(tradingPlan.plans_accounts_deactivation);
  const limitPriceDisabled = disabled || isTournamentEnded || !isTournamentStarted;

  return (
    <>
      <div className={styles.wrapperLimitMarketPrice}>
        <div className={disabled ? styles.limitInputDisabled : ''}>
          {orderType === OrderTypeEnum.Stop
            ? lang.mobileTradingTicketStopPrice2()
            : lang.mobileTradingTicketLimitPrice()}
        </div>
        <CurrencyInput
          decimalSeparator={decimalSeparator}
          groupSeparator={groupSeparator}
          defaultValue={initialPrice}
          onValueChange={(amount) => {
            if (amount && isIosUser) {
              setTargetPrice(Number(amount.replace(',', '.')));
            } else {
              setTargetPrice(Number(amount));
            }
            setTargetPriceError('');
          }}
          onFocus={onFocus}
          onBlur={onBlur}
          className={classNames(styles.wrapperPriceField, { [styles.limitInputDisabled]: limitPriceDisabled })}
          placeholder="$0.00"
          allowNegativeValue={false}
          prefix={'$'}
          maxLength={14}
        />
      </div>
      {(targetPriceError.trim() !== '') && (
        <div className={styles.errorWrapper}>
          <Error hiddenIcon errorMessage={targetPriceError} />
        </div>
      )}
    </>
  );
};

export default LimitPriceInput;
